<ul class="progressbar d-none d-md-flex" [class.show-numbers]="showNumbers">
  <li *ngFor="let step of steps" [class.active]="step.active" [ngClass]="{'contentEmpty': step.label === 'Processing'}" [class.completed]="step.completed" [style.width]="100 / steps.length + '%'">
    <span>{{ step.label }}</span>
    <p class="paragraph-text text-grey px-3 mt-2">{{ step.body }}</p>
  </li>
</ul>

<div class="mobile-container" *ngIf="!showNumbers">
  <ul class="progressbar-mobile d-md-none">
    <li class="progressbar-mobile-item" *ngFor="let step of steps" [class.active]="step.active && !step.completed" [class.completed]="step.completed">
      {{ step.label }}
    </li>
  </ul>
</div>

<div class="text-left" *ngIf="showNumbers">
  <div class="d-md-none mb-4" *ngFor="let step of steps; let i = index">
    <div class="number-circle mb-2">{{ i + 1 }}</div>
    <div class="subhead mb-2">{{ step.label }}</div>
    <div class="paragraph-text text-grey">{{ step.body }}</div>
  </div>
</div>
